define("powergen/models/keyboard-row",
  [],
  function() {
    "use strict";
    var KeyboardRow;

    KeyboardRow = DS.Model.extend({
      keys: DS.hasMany('keyboardKey')
    });


    return KeyboardRow;
  });